import * as ajax from '@/shared/API/UI/ajax';
// import * as rest from '@/shared/entities/Workspace/apis/rest';

import getFactory from '@/shared/utils/factory';

// import type { LoadAllUsersPayload } from '@/shared/DTO/SYS';
import type { GetFolderButtonPayload } from '@/shared/DTO/GED';
import type { Payload } from '@/shared/utils/factory';

const factory = getFactory<typeof ajax>(ajax);

export function useBlocksUIApi() {
    return {
        getFolderButtonInfo: (payload: Payload<GetFolderButtonPayload>) => factory.getFolderButtonInfo(payload),
    };
}
